"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CartProduct = require("./CartProduct");

var _CartProduct2 = _interopRequireDefault(_CartProduct);

var _HeaderContext = require("../HeaderContext");

var _HeaderContext2 = _interopRequireDefault(_HeaderContext);

var _bodyScrollLock = require("body-scroll-lock");

var _tooltip = require("../Tooltip/tooltip");

var _tooltip2 = _interopRequireDefault(_tooltip);

require("./MobileCartMenu.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MobileCartMenu = function (_Component) {
  _inherits(MobileCartMenu, _Component);

  function MobileCartMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MobileCartMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MobileCartMenu.__proto__ || Object.getPrototypeOf(MobileCartMenu)).call.apply(_ref, [this].concat(args))), _this), _this.displayShippingFee = function (fees) {
      if (!fees) {
        return "";
      }

      if (parseFloat(fees.shipping) === 0.0) {
        return "FREE";
      }

      return "$" + fees.shipping;
    }, _this.formatCreditApplied = function (credit) {
      if (credit == null) {
        return "";
      }

      var parsedCredit = parseFloat(credit);

      if (parsedCredit == 0.0) {
        return "$0.00";
      }

      if (parsedCredit > 0) {
        return "-$" + credit;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MobileCartMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _bodyScrollLock.disableBodyScroll)(document.querySelector("#cart-product-list"));
      this.addPaddingToProductListing();
      window.addEventListener("resize", this.addPaddingToProductListing);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
      window.removeEventListener("resize", this.addPaddingToProductListing);
    }
  }, {
    key: "addPaddingToProductListing",
    value: function addPaddingToProductListing() {
      var header = document.querySelector("#cart-header");
      var footer = document.querySelector("#cart-footer");
      var productListing = document.querySelector(".mobile-cart-submenu .cart-product-listing");

      if (footer && productListing && header) {
        productListing.style.marginBottom = footer.scrollHeight + header.scrollHeight + "px";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          callbacks = _props.callbacks,
          campaignId = _props.campaignId,
          cartText = _props.cartText,
          products = _props.products,
          total = _props.total,
          subtotal = _props.subtotal,
          fees = _props.fees,
          remainingCredit = _props.remainingCredit,
          appliedAddonCredit = _props.appliedAddonCredit,
          appliedPurchaseCredit = _props.appliedPurchaseCredit,
          expandProductDetails = _props.expandProductDetails;
      var setExpandedMenu = callbacks.setExpandedMenu,
          updateCart = callbacks.updateCart;
      return _react2.default.createElement("div", {
        id: "mobile-cart-submenu",
        className: "mobile-cart-submenu pos-f z-3000"
      }, _react2.default.createElement("div", {
        className: "h-100 pos-r"
      }, _react2.default.createElement("div", {
        id: "cart-header"
      }, _react2.default.createElement("div", {
        className: "mobile-cart-header ta-center"
      }, _react2.default.createElement("i", {
        onClick: function onClick() {
          return setExpandedMenu({
            id: ""
          });
        },
        className: "ion-close close-mobile-cart"
      }), _react2.default.createElement("span", null, "My Cart")), remainingCredit != null && _react2.default.createElement("div", {
        className: "d-flex flex-jsb fs-12 c-white credit-remaining fw-mid"
      }, _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, "Credit Remaining"), _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, "$" + remainingCredit))), children && children.map(function (child) {
        if (child.placementIndex < 1) {
          return _react2.default.createElement(_react2.default.Fragment, {
            key: child.key
          }, child.component);
        }
      }), _react2.default.createElement("div", {
        id: "cart-product-list"
      }, _react2.default.createElement("ul", {
        className: "pad-0 mar-0 cart-product-listing"
      }, !!products && products.map(function (item) {
        return _react2.default.createElement("div", {
          key: item.id
        }, item.variants && item.variants.map(function (variant) {
          return _react2.default.createElement("li", {
            key: variant.id
          }, _react2.default.createElement(_CartProduct2.default, {
            id: item.id,
            name: item.name,
            variant: variant,
            quantity: variant.quantity,
            color: variant.color,
            inventoryState: variant.inventoryState,
            imageUrl: variant.imageUrl,
            salePrice: item.salePrice,
            callbacks: callbacks,
            campaignId: campaignId,
            cartLimit: variant.cartLimit,
            cartAmount: variant.cartAmount,
            isMobile: true,
            descriptor: variant.descriptor,
            expandProductDetails: expandProductDetails,
            shareUrl: item.shareUrl,
            legacyPostId: item.legacyPostId
          }));
        }));
      }))), !products || !products.length && _react2.default.createElement("div", {
        className: "italic fs-12 ta-center pad-16"
      }, "Your cart is currently empty...", _react2.default.createElement("br", null), "treat yourself and start shopping :)"), _react2.default.createElement("div", {
        id: "cart-footer",
        className: "cart-menu-footer pos-a w-100-vw"
      }, appliedAddonCredit != null && _react2.default.createElement("div", {
        className: "d-flex flex-jsb fs-12 credit-applied pad-8"
      }, _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, "Credit Applied"), _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, this.formatCreditApplied(appliedAddonCredit))), appliedPurchaseCredit != null && _react2.default.createElement("div", {
        className: "d-flex flex-jsb fs-12 pad-8"
      }, _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, "Purchase Credits Applied"), _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, this.formatCreditApplied(appliedPurchaseCredit))), fees && fees.tax != null && _react2.default.createElement("div", {
        className: "d-flex flex-jsb subtotal fs-12 pad-w-8 mar-b-4"
      }, _react2.default.createElement("p", {
        className: "mar-0 pad-0 fw-bold"
      }, "Subtotal"), _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, "$" + subtotal)), fees && fees.shipping != null && _react2.default.createElement("div", {
        className: "shipping fs-12 pad-w-8 mar-b-4"
      }, _react2.default.createElement("div", {
        className: "d-flex flex-jsb"
      }, _react2.default.createElement("p", {
        className: "mar-0 pad-0 fw-bold"
      }, "Shipping"), _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, this.displayShippingFee(fees))), !!fees.amountToFreeShipping && fees.amountToFreeShipping > 0 && _react2.default.createElement("div", {
        className: "fs-11 fw-mid d-flex mar-t-4"
      }, "Add", _react2.default.createElement("span", {
        className: "c-brand fw-bold"
      }, "\xA0$" + fees.amountToFreeShipping + "\xA0"), "to get free shipping")), fees && fees.processing != null && _react2.default.createElement("div", {
        className: "d-flex flex-jsb fs-12 addl-shipping fs-12 pad-w-8 mar-b-4"
      }, _react2.default.createElement("div", {
        className: "mar-0 pad-0"
      }, "Add'l Shipping & Handling", _react2.default.createElement(_tooltip2.default, {
        text: "Add'l shipping & handling for customers with shipping address in Hawaii, Alaska, Puerto Rico, Canada, and UK",
        icon: "help"
      })), _react2.default.createElement("div", {
        className: "mar-0 pad-0"
      }, "$" + fees.processing)), fees && fees.tax != null && _react2.default.createElement("div", {
        className: "d-flex flex-jsb tax fs-12 pad-w-8 mar-b-4"
      }, _react2.default.createElement("p", {
        className: "mar-0 pad-0 fw-bold"
      }, "Tax"), _react2.default.createElement("p", {
        className: "mar-0 pad-0"
      }, "$" + fees.tax)), _react2.default.createElement("div", {
        className: "mobile-cart-sub-copy w-100-vw"
      }, _react2.default.createElement("div", {
        className: "mar-10"
      }, _react2.default.createElement("p", {
        className: "mar-0 pad-0 ta-left fs-12",
        dangerouslySetInnerHTML: {
          __html: cartText
        }
      }))), _react2.default.createElement("div", {
        className: "total-bar d-flex flex-jsb  w-100-vw"
      }, _react2.default.createElement("div", {
        className: "c-white mar-10"
      }, "TOTAL"), _react2.default.createElement("div", {
        className: "c-white mar-10"
      }, "$", total)))), children && children.map(function (child) {
        if (child.placementIndex > 1) {
          return _react2.default.createElement(_react2.default.Fragment, {
            key: child.key
          }, child.component);
        }
      }), _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
        return _react2.default.createElement("div", {
          className: "cart-page-overlay",
          onClick: function onClick() {
            return context.setExpandedMenu();
          }
        });
      }));
    }
  }]);

  return MobileCartMenu;
}(_react.Component);

exports.default = MobileCartMenu;